// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__297xT","header":"ClearentDisclaimer_header__C5Qfx","inner":"ClearentDisclaimer_inner__30Foa"};